<template>
  <div class="fl-bg">
    <div v-if="bgBottom" class="bg-bottom"><img :src="bgBottom" /></div>
    <div v-if="bgTop" class="bg-top"><img :src="bgTop" show-menu-by-longpress="true" /></div>
  </div>
</template>

<script>
import { getConfigImg } from "../../api"
import { isWeixin } from '../../utils'

export default {
  name: 'OnlineQrcode',
  data(){
    return {
      bgBottom: '',
      bgTop: '',
    }
  },
  created() {
    if (location.href.indexOf('?') === -1 && !this.$route.query.utm_source) { // 只判断从产品外包装过来的，什么参数都不带的情况
      location.href = `${location.href}?utm_source=productPakagaing`
    }
  },
  mounted(){
    this.getBgImage()
    this.getQrcodeImage()
    if (!isWeixin()) {
      this.$dialog.alert({
        confirmButtonColor: '#E45D50',
        message: '请使用微信扫码或截图当前页面在微信中扫码识别',
        theme: 'round-button',
        confirmButtonText	: '我知道了',
        className: 'onlineqrcode-custom-alert'
      }).then(() => {
        console.log('confirm')
      });
    }
   // document.title = this.$route.query.title || '';
  },
  methods:{
    getBgImage () {
      const code = this.$route.query.codebg
      let param
      code ? param = code : param = 'cotti-my-socialGroup-bg-banner-packging'
      getConfigImg({code: param}).then(res=> {
        console.log('res-----', res);
        if (res.data.length > 0) {
          const result = res.data[0]
          this.bgBottom = result.url
          document.title = result.title || '';
          this.$sensors.track("generic_ad_banner_show_event", {
            position_code: result.positionCode,
            position_name: result.positionName,
            view_page: `${document.title}-${location.href}`,
            position_type: result.bannerType + '',
            position_order: result.sort
          });
        }
      })
    },
    getQrcodeImage () {
      const code = this.$route.query.codeqrcode
      let param
      code ? param = code : param = 'cotti-my-socialGroup-banner-packging'
      getConfigImg({code: param}).then(res=> {
        console.log('res-----', res);
        if (res.data.length > 0) {
          const result = res.data[0]
          this.bgTop = result.url
          this.$sensors.track("generic_ad_banner_show_event", {
            position_code: result.positionCode,
            position_name: result.positionName,
            view_page: `${document.title}-${location.href}`,
            position_type: result.bannerType + '',
            position_order: result.sort
          });
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fl-bg {
  position: relative;
  height: 100%;
  .bg-bottom {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    img {
      width: 100%;
      vertical-align: top;
    }
  }
  .bg-top {
    position: absolute;
    top: 464px;
    left: 50%;
    margin-left: -327px;
    img {
      width: 654px;
      height: 760px;
    }
  }
}
</style>

<style lang="scss">
.onlineqrcode-custom-alert {
  border-radius: 0;
  .van-button {
    border-radius: 0;
  }
}
</style>
